/**
 * Resolve CMS/API media fields that may be a URL string, JSON, object, or array.
 */
import { extractFirstImageSrcFromHtml, resolveCmsImageUri } from './resolveCmsImageUri';
import { resolveImageUri } from './resolveImageUri';

function resolve_string_media(trimmed: string): string | null {
  if (!trimmed) {
    return null;
  }
  if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
    try {
      return resolveMediaUri(JSON.parse(trimmed));
    } catch {
      // Not JSON — treat as path/URL below.
    }
  }
  const from_html = extractFirstImageSrcFromHtml(trimmed);
  if (from_html) {
    const resolved_html = resolveImageUri(from_html);
    if (resolved_html) {
      return resolved_html;
    }
  }
  return resolveImageUri(trimmed) ?? resolveCmsImageUri(trimmed);
}

/**
 * Resolve thumbnails, attachments, and nested API media to an absolute image URL.
 */
export function resolveMediaUri(raw: unknown): string | null {
  if (raw == null) {
    return null;
  }
  if (typeof raw === 'string') {
    return resolve_string_media(raw.trim());
  }
  if (Array.isArray(raw)) {
    for (const item of raw) {
      const resolved = resolveMediaUri(item);
      if (resolved) {
        return resolved;
      }
    }
    return null;
  }
  if (typeof raw === 'object') {
    const record = raw as Record<string, unknown>;
    for (const key of ['url', 'src', 'path', 'image', 'thumbnail', 'attachment', 'file', 'file_url', 'image_url']) {
      const resolved = resolveMediaUri(record[key]);
      if (resolved) {
        return resolved;
      }
    }
  }
  return null;
}

/** Category/plan `attachment` fields (string, JSON, or object). */
export function resolveAttachmentUri(raw: unknown): string | null {
  return resolveMediaUri(raw);
}
